import { callLoader } from '@/redux/Loader/actions';
import { USER_LIST, USER_PAGINATION } from './constant';
import { APICall } from '@/config/NetworkUtility';

/**
 * Fetch paginated user list
 */
export const getUserList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({ ...payload }).toString();
            const url = `v1/Users/GetUserList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
           
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: USER_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: USER_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};

/**
 * Fetch single user by ID
 */
// export const getUserByID = (payload) => {
//     return dispatch => {
//         try {
//             dispatch(callLoader(true));
//             const url = `v1/Users/GetUserByID?UserId=${payload}`;
//             return APICall('get', payload, url).then(result => {
//                 if (result?.statuscode === 200) {
//                     return result?.data;
//                 } else {
//                     return Promise.reject();
//                 }
//             }, error => {
//                 return Promise.reject(error);
//             });
//         } catch (error) {
//             console.log(error);
//             return Promise.reject(error);
//         } finally {
//             dispatch(callLoader(false));
//         }
//     };
// };

/**
 * Create or update a user via SaveUserInfo
 */
export const saveUserInfo = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const url = `v1/Users/InsertUserInfo`;
            return APICall('post', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result;
                } else {
                    return Promise.reject(result);
                }
            }, error => {
                dispatch(callLoader(false));
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};
export const UpdateUserInfo = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const url = `v1/Users/UpdateUserInfo`;
            return APICall('post', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result;
                } else {
                    return Promise.reject(result);
                }
            }, error => {
                dispatch(callLoader(false));
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};